import { useCrossHair } from "../../contexts/CrossHair";
import { useRoot } from "../../contexts/Root";
import { HandlerShape } from "../../types/handlerShape";
import { Handler } from "./Handler";

export const CrossHairHandler = () => {
  const {
    theme: { foreground },
  } = useRoot();

  const { offset, show } = useCrossHair();

  return (
    <Handler
      shape={HandlerShape.strip}
      offset={offset}
      zIndex={5}
      color={foreground}
      show={show}
    />
  );
};
